// Fenêtre « Renommer un produit partout » : ce que le renommage touche, en phrases courtes.
const MONTH_NAMES = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"];

function joinWithEt(parts) {
  return parts.length < 2 ? parts.join("") : `${parts.slice(0, -1).join(", ")} et ${parts[parts.length - 1]}`;
}

// « 14, 15 et 16 octobre », « 30 septembre et 1er octobre ».
function formatOpenDates(isoDates) {
  const months = [];
  for (const isoDate of isoDates) {
    const [, month, day] = String(isoDate).split("-").map(Number);
    const dayLabel = day === 1 ? "1er" : String(day);
    const last = months[months.length - 1];
    if (last && last.month === month) last.days.push(dayLabel);
    else months.push({ month, days: [dayLabel] });
  }
  return joinWithEt(months.map(({ month, days }) => `${joinWithEt(days)} ${MONTH_NAMES[month - 1] || ""}`.trim()));
}

function countLabel(count, singular, plural) {
  return `${count} ${count > 1 ? plural : singular}`;
}

export function buildRenameImpactItems(oldName, newName, preview) {
  const renamed = [];
  const dates = Array.isArray(preview?.open_dates) ? preview.open_dates : [];
  if (preview?.orders_to_rename > 0) {
    const where = dates.length === 1 ? `de la journée ouverte du ${formatOpenDates(dates)}`
      : dates.length > 1 ? `des journées ouvertes (${formatOpenDates(dates)})` : "sans date";
    renamed.push(`${countLabel(preview.orders_to_rename, "commande", "commandes")} ${where} et leurs tournées`);
  }
  if (preview?.product_codes > 0) renamed.push(countLabel(preview.product_codes, "code produit", "codes produit"));
  if (preview?.trailers > 0) renamed.push(`${countLabel(preview.trailers, "remorque", "remorques")} (produit associé)`);
  if (preview?.loading_clients > 0) renamed.push(`${countLabel(preview.loading_clients, "client de chargement", "clients de chargement")} (Paramètres système)`);
  return [
    ...(renamed.length ? [`Renommés : ${renamed.join(" ; ")}.`] : []),
    ...(preview?.orders_kept > 0 ? [`Gardent « ${oldName} » : ${countLabel(preview.orders_kept, "commande", "commandes")} des journées clôturées (historique, facturation).`] : []),
    `Un import ou un fichier qui envoie encore « ${oldName} » recevra « ${newName} ».`,
    "La couleur du produit au Gantt peut changer.",
  ];
}

export function isProductInUse(preview) {
  return ["orders_to_rename", "orders_kept", "product_codes", "trailers", "loading_clients"].some((key) => Number(preview?.[key]) > 0);
}
